/**
 * Recognising the action column, shared by AppTable (which places it) and the
 * report-table column schema (which lists it for freezing and visibility).
 *
 * Kept free of imports so either side can depend on it without a cycle.
 */

const ACTION_KEYS = new Set(["action", "actions", "operation", "operations"])

/** The label an untitled action column is given wherever it is named. */
export const ACTION_COLUMN_TITLE = "Action"

/**
 * Is this the action column? Matches the conventions actually in use: an
 * `action`/`operation` key or dataIndex, or a title of "Action(s)". Titles are
 * often empty on these columns, so the key is the more reliable signal.
 */
export const isActionColumn = (column: any) => {
  const key = String(column?.key ?? "").toLowerCase()
  const dataIndex = String(column?.dataIndex ?? "").toLowerCase()
  const title =
    typeof column?.title === "string" ? column.title.toLowerCase() : ""
  return (
    ACTION_KEYS.has(key) ||
    ACTION_KEYS.has(dataIndex) ||
    ACTION_KEYS.has(title.trim())
  )
}
